import { z } from 'zod';

import { zodContractStatusSchema } from '../validations';

export const zodContractPermissionsResponseSchema = z.object({
  appendOnlyFields: z.array(z.string()),
  editableFields: z.array(z.string()),
  readonlyFields: z.array(z.string()),
  status: zodContractStatusSchema,
});
